import { useTranslation } from 'react-i18next';

interface TroubleshootProps {
    link: string;
}

export const Troubleshoot = ({ link }: TroubleshootProps) => {
    const { t } = useTranslation();

    return (
        <div className="mt-8 border-t border-dashed border-primary">
            <p className="py-3">{t('Broadcaster.Status.Troubleshoot.Text')}</p>
            <a href={link} target="_blank" rel="noopener noreferrer" className="w-full btn--outline-primary">
                {t('Broadcaster.Status.Troubleshoot.Button')}
                <span className="sr-only">{t('Generic.Link.OpensInNewTab')}</span>
            </a>
        </div>
    );
};
